

$(function(){

$('body').on('click','.BrandsListMedia_indexLetter__dD1bg',function(evt){
  evt.preventDefault();
  evt.stopImmediatePropagation();
  $('.BrandsListMedia_indexLetter__dD1bg').removeClass('BrandsListMedia_indexSelected__1zA4u');
    $(this).addClass('BrandsListMedia_indexSelected__1zA4u');
  
let letter = $(this).attr('href').replace('#','');
  console.log(letter);

 let letter_parent = $(`.letter-${letter}`).parent();
  if( letter != 'all'){
  $('.BrandsLetterBlock_letterBlock__2XzWv, .BrandsLetterBlockMedia_letterBlock__3dMmQ').not(letter_parent).hide();
  letter_parent.show(); 
  }else  $('.BrandsLetterBlock_letterBlock__2XzWv, .BrandsLetterBlockMedia_letterBlock__3dMmQ').show();
  
});

$('body').on('click','.BrandsHeader_listContent__1bvSw',function(){
    $('.BrandsHeader_listContent__1bvSw').removeClass('BrandsHeader_enable__3erGk');
    $(this).addClass('BrandsHeader_enable__3erGk');
if($(this).hasClass('list-view')){
$('.list_view').show();
  $('.gallery_view').hide();
  
}else{
  $('.list_view').hide();
  $('.gallery_view').show();
}
    
  });

  $('body').on('keyup change','.Input_root__2vmVG.BrandsHeader_searchBar__1BwUt',function(){
let val =  $(this).val().toLowerCase();
    console.log(val);

    

let all_elems_list = $('.BrandsLetterBlock_letterBlock__2XzWv');
    let all_elems_gallery = $('.BrandsLetterBlockMedia_letterBlock__3dMmQ');
  
    
    $.each(all_elems_list, function(index, elem){
if($(elem).is(':visible')){
  let all_lis = $(elem).find('.BrandsLetterBlock_brand__2V2Il')
    $.each(all_lis, function(index, an_ali){
      console.log($(an_ali).find('a').text());
      if($(an_ali).find('a').text().toLowerCase().indexOf(val)>-1){
        $(an_ali).show();
      }else{
        $(an_ali).hide();
      }
      
    })
  
}
    });
    $.each(all_elems_gallery, function(index, elem){
if($(elem).is(':visible')){
    let all_lis = $(elem).find('.BrandsLetterBlockMedia_brand__1OXiK')
    $.each(all_lis, function(index, an_ali){
      console.log($(an_ali).find('p.BrandsLetterBlockMedia_brandName__1FhTA').text());
      if($(an_ali).find('p.BrandsLetterBlockMedia_brandName__1FhTA').text().toLowerCase().indexOf(val)>-1){
        $(an_ali).show();
      }else{
        $(an_ali).hide();
      }
      
    })
}
    });
    
  });


$('.close-popup').click(function(e){
   e.preventDefault();
  $('.popup-custom').addClass('hide');
  
});
   $(".logo-bar__item > a[href='/pages/brands']").on("click", function (e) {
        e.preventDefault()
$('.popup-custom').removeClass('hide');
     
     /*
     $.ajax({
		type		: "GET",
		cache	: false,
		url		: "/pages/brands?view=_inline_brands",
		success: function(data) {
			$.fancybox(data,{
  afterShow: function() {
    $('body').addClass('overflow-hidden');
  },
  beforeClose: function() {
    $('body').addClass('overflow-hidden');
  }
});
		}
	});
   
   */
   
   
   })


  
});

